'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import { DateSelection } from '@repo/ui/DateSelection'

export const TimeRecordingDateFilter = ({ value = new Date(), onChange }) => {
  const handleDateSelect = (date) => {
    date.setHours(0, 0, 0, 0)
    onChange(date)
  }

  return (
    <MUIStack gap={4} direction="row" alignItems="center" flexWrap={'wrap'} data-testid="TimeRecordingDateFilter">
      <DateSelection
        format="d MMM yyyy"
        value={value}
        onChange={handleDateSelect}
        size="medium"
        sx={{
          '.MuiOutlinedInput-root': {
            display: 'none' // hide the visible text input
          },
          '.MuiFormLabel-root': {
            display: 'none' // hide the visible label
          }
        }}
        timeRecordingDateFilter
      />
    </MUIStack>
  )
}

TimeRecordingDateFilter.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func
}
